import FeatSDKV1 from 'api/version1';
import { createEffect } from 'effector';

export const getFeaturesByPlaceIdFx = createEffect(
  FeatSDKV1.features.getFeaturesByPlaceId,
);
